<app-toaster *ngIf="showToast" [message]="toastMessage" [type]="toastType"></app-toaster>

<!-- Modal -->
<div class="modal fade" id="UploadAttachments" tabindex="-1" aria-labelledby="membershipModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="membershipModalLabel">{{"MEMBERSHIP.ADD_BILL_IMAGES"|translate}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeMembershipModal()"></button>
            </div>
            <div class="modal-body">

                <form [formGroup]="AttachmentsForm" (ngSubmit)="onAttachementSubmit()">

                    <div class="form-group col-md-12">
                        <label>{{"MEMBERSHIP.BILLIMAGES" | translate}}<span class="required">*</span></label>
                        <input type="file" name="attachments" multiple (change)="onFilesSelected($event)"
                            class="form-control" />
                        <img *ngFor="let url of previewUrls" [src]="url" alt="attachment preview" width="120"
                            height="120" style="margin:10px" />
                    </div>

                    <div class="form-group col-md-12">
                        <label>{{"MEMBERSHIP.NOTES" | translate}}<span class="info-icon">i
                                <span class="tooltip-text">
                                  {{"MEMBERSHIP.NOTE_DESCRIPTION" | translate}}  
                                </span>
                            </span></label>
                        <input type="text" formControlName="note" class="form-control" />
                    </div>
                    <div class="col-md-12 contact-form-style-2">
                        <button type="submit" class="btn btn-fill-out submit font-weight-bold mt-2" name="submit"
                            value="Submit" data-bs-dismiss="modal" aria-label="Close">
                            {{"PROFILE.SUBMIT" | translate}}</button>
                    </div>
                </form>

            </div>
        </div>
    </div>
</div>